import React, { Component } from 'react';
import './Item.css'
import ConfigFixingListModal from 'component/element/ConfigFixingListModal'
import {connect} from 'react-redux'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    let {messages} = this.props
    return(
  		<div>
        <h3>{messages['Fixing Config']}</h3>
  			<ConfigFixingListModal
          mode='form'
        />
  		</div>
  	)
  }

}
 
// export default Item;
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu5.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu5/Item.js